<template>
  <div class="p-6 flex flex-col gap-6">
    <h2 class="text-lg font-bold">Market data</h2>
    <div class="w-full flex items-center gap-2">
      <div class="flex flex-col gap-1 text-sm">
        <label for="ativo"> Ativo </label>
        <select name="ativo" class="bg-ontick-graphite-500 rounded border-0">
          <option value="WINFUT">WINFUT</option>
          <option value="WDOFUT">WDOFUT</option>
          <option value="CCMFUT">CCMFUT</option>
        </select>
      </div>
      <div class="flex flex-col gap-1 text-sm">
        <label for="ativo"> Timeframe </label>
        <select name="ativo" class="bg-ontick-graphite-500 rounded border-0">
          <option value="T1">T1</option>
          <option value="T5">T5</option>
          <option value="T10">T10</option>
        </select>
      </div>
    </div>
    <ontick-lightweight-charts-component :candlestickSeries="candles()" />
  </div>
</template>

<script>
import ontickLightweightChartsComponent from "@/app/shared/components/basic/ontick-lightweight-charts.component.vue";
export default {
  components: { ontickLightweightChartsComponent },

  methods: {
    candles() {
      let { green, red } = this.$colors;
      let positive = green[600];
      let negative = red[600];
      return {
        upColor: positive,
        borderUpColor: positive,
        wickUpColor: positive,
        downColor: negative,
        borderDownColor: negative,
        wickDownColor: negative,
      };
    },
  },
};
</script>

<style></style>
